import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router';
import ConfigTab from '../../../component/configurationTab/configurationTab';
import Title from '../../../component/title/Title';
import { FLEET_AI_ENABLED, REPORTS_ENABLED } from '../../../config/featureFlags';
import './fleets.css';

const navigationList = [
    {
        text: 'Profile',
        value: 1,
        path: '/settings/profile',
        enabled: true,
    },
    {
        text: 'Security',
        value: 2,
        path: '/settings/security',
        enabled: true,
    },
    {
        text: 'Team',
        value: 3,
        path: '/settings/teams',
        enabled: true,
    },
    {
        text: 'Notifications',
        value: 4,
        path: '/settings/notifications',
        enabled: true,
    },
    {
        text: 'Fleet AI',
        value: 5,
        path: '/settings/fleets',
        enabled: FLEET_AI_ENABLED,
    },
    {
        text: 'Reports',
        value: 6,
        path: '/settings/reports',
        enabled: REPORTS_ENABLED,
    },
];

const Fleets = (props) => {
    const { totalUsers } = props;
    const [fleetAIQueryCount, setFleetAIQueryCount] = useState(0);
    const [navigtionClick, setNavigtionClick, navigationState, setNavigationState] = useOutletContext();

    useEffect(() => {
        setNavigationState('settings');
        setNavigtionClick(5);
        const storedCount = Number(localStorage.getItem('fleetAIQueryCount') || '0');
        setFleetAIQueryCount(Number.isNaN(storedCount) ? 0 : storedCount);
    }, []);

    const usageLimit = 1000;
    const used = Math.min(fleetAIQueryCount, usageLimit);
    const remaining = Math.max(usageLimit - used, 0);
    const usedPercentage = (used / usageLimit) * 100;

    return (
        <div className="fleet-container">
            <div className="fleet-header-section">
                <div className="fleet-title">
                    <Title title="Settings" titleSize="1.875rem" lineHeight="2.375rem" />
                </div>
                <div className="fleet-tabs">
                    <ConfigTab
                      color="#FCFCFD"
                      module="settings"
                      types={navigationList}
                      users={totalUsers}
                      navigtionClick={navigtionClick}
                      setNavigtionClick={setNavigtionClick}
                    />
                </div>
            </div>

            <div className="fleets-usage-section">
                <div className="fleets-usage-header">
                    <div className="fleets-usage-header-text">
                        <h2 className="fleets-usage-title">Personal Usage</h2>
                        <p className="fleets-usage-subtitle">
                            View and track your remaining query balance to ensure continuous access to system insights and operational data.
                        </p>
                    </div>
                </div>

                <div className="fleets-usage-grid">
                    <div className="fleets-usage-card">
                        <div className="fleets-usage-card-header">
                            <span className="fleets-usage-card-title">Usage</span>
                        </div>
                        <div className="fleets-usage-card-body">
                            <div className="fleets-usage-main">
                                <div className="fleets-usage-number-block">
                                    <span className="fleets-usage-number">
                                        {used}
                                        /&nbsp;
                                        {usageLimit}
                                    </span>
                                    <span className="fleets-usage-label">Balance used</span>
                                </div>
                            </div>
                            <div className="fleets-usage-progress">
                                <div className="fleets-usage-bar-bg">
                                    <div
                                      className="fleets-usage-bar-fill"
                                      style={{ width: `${usedPercentage}%` }}
                                    />
                                </div>
                                <div className="fleets-usage-progress-caption">
                                    {remaining > 0
                                        ? `${remaining} queries remaining`
                                        : 'You have reached your 1000 query limit.'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Fleets;
